<div class="modal-content">
  <ng-container *ngComponentOutlet="content as any"></ng-container>
</div>
